module.exports = __webpack_public_path__ + "img/2.1791eab9.jpg";